import React, { Component } from 'react';
import { Table, Tag, Tooltip } from 'antd';
import NumberFormat from 'react-number-format';
import { renderReceiptStatus, renderReceiptRefundStatus, renderPaymentMethod, isValidDate, stripHtml, renderMoney } from '@/utils/helpers';
import TextTruncate from 'react-text-truncate';
import HtmlParser from 'react-html-parser';
import { QuestionCircleOutlined } from '@ant-design/icons';

class CustomerReceiptsTable extends Component {

    columns = [
        {
            title: 'STT',
            key: 'index',
            width: '40px',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Mã phiếu',
            dataIndex: 'code',
            key: 'code',
            width: '100px'
        },
        {
            title: 'Ngày TT',
            dataIndex: 'payment_at',
            key: 'payment_at',
            render: (text, record) => {
                if (text && text !== '') {
                    return (
                        <>{isValidDate(text, false)}</>
                    )
                } else {
                    return (<Tag></Tag>)
                }
            }
        },
        {
            title: 'Tổng cộng',
            dataIndex: 'total_amount',
            key: 'total_amount',
            render: (text, record) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            )
        },
        {
            title: 'Ưu đãi',
            dataIndex: 'special_discount',
            key: 'special_discount',
            render: (text, record) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            )
        },
        {
            title: 'Doanh số',
            dataIndex: 'adjusted_sales',
            key: 'adjusted_sales',
            render: (text, record) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            )
        },
        {
            title: 'Số tiền TT',
            dataIndex: 'amount_paid',
            key: 'amount_paid',
            render: (text) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            ),
        },
        {
            title: 'Tổng đã TT',
            dataIndex: 'total_amount_paid',
            key: 'total_amount_paid',
            render: (text) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            ),
        },
        {
            title: (
                <span>
                    Công nợ{' '}
                    <Tooltip title="Công nợ ngay sau khi ghi nhận phiếu thu này. Các khoản thu, hoàn tiền hoặc thay đổi dịch vụ sau đó có thể làm số này khác công nợ hiện tại của khách.">
                        <QuestionCircleOutlined style={{ color: '#8c8c8c', cursor: 'help' }} />
                    </Tooltip>
                </span>
            ),
            dataIndex: 'remaining_debt',
            key: 'remaining_debt',
            render: (text) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            ),
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            width: '120px',
            render: (text, record) => {
                return (
                    <>
                        {renderReceiptStatus(text)}
                        {renderReceiptRefundStatus(record?.refund_summary?.status)}
                    </>
                )
            }
        },
        {
            title: 'Phương thức TT',
            dataIndex: 'payment_method',
            key: 'payment_method',
            render: (text, record) => {
                return (
                    <>{(record.payment_breakdowns || record.paymentBreakdowns || []).length
                        ? (record.payment_breakdowns || record.paymentBreakdowns).map(row => <div key={row.id || row.payment_method}>
                            {renderPaymentMethod(row.payment_method)} <strong>{renderMoney(row.amount)}</strong>
                        </div>) : renderPaymentMethod(text)}</>
                )
            }
        },
        {
            title: 'Ghi chú',
            dataIndex: 'note',
            key: 'note',
            width: '200px',
            render: (text, record) => {
                return (
                    <div style={{ wordBreak: "break-word" }}>
                        <Tooltip title={HtmlParser(text)} placement="topLeft">
                            <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                        </Tooltip>
                    </div>
                )
            }
        }
    ];


    render() {

        return (
            <>
                <Table
                    size='small'
                    columns={this.columns}
                    dataSource={this.props.data ?? []}
                    pagination={false}
                    locale={{ emptyText: "Chưa có dữ liệu" }}
                    scroll={{
                        x: 'max-content'
                    }}
                />
            </>
        );
    }
}

export default CustomerReceiptsTable;
